import React, { FunctionComponent, useEffect, useState } from 'react';
import { DefaultButton, Dialog, DialogFooter, SharedColors, Stack, Text } from '@fluentui/react';
import { rbacSync } from '../../../services/groupRoles.service';
import { SalusPrimaryButton } from '../../shared/SalusPrimaryButton';
import { QueueConfiguration, trackException } from '../../../services';
import { AxiosError } from 'axios';

interface RBACSyncDialogProps {
  showRBACSyncDialog: boolean;
  setShowRBACSyncDialog: React.Dispatch<React.SetStateAction<boolean>>;
  queueDataState: QueueConfiguration;
}

export const RBACSyncDialog: FunctionComponent<RBACSyncDialogProps> = (props): JSX.Element => {
  const [addGroupRoleErrorMessage, setAddGroupRoleErrorMessage] = useState('');
  const [subText, setSubText] = useState(
    'An RBAC Sync will apply the group role permissions defined on this page to your queue. This process happens nightly, but you can expedite it by performing an RBAC Sync manually here. This manual option takes ~15 minutes.'
  );
  const [syncComplete, setSyncComplete] = useState(false);

  const ableToSync = (): boolean => {
    return !!props.queueDataState.useUsersFromAadGroup;
  };

  useEffect(() => {
    if (!ableToSync()) {
      setSubText('This queue is not setup to work with group roles. Please contact GMX Support.');
    }
  }, [props.queueDataState.useUsersFromAadGroup]);

  const onRbacSyncClick = () => {
    rbacSync(
      props.queueDataState?.tenant.tenantId,
      props.queueDataState?.title.titleId,
      props.queueDataState?.subjectType
    )
      .then(() => {
        setSyncComplete(true);
        setAddGroupRoleErrorMessage('');
        setSubText('Sync completed successfully! Verify expected access in fifteen minutes.');
      })
      .catch((err: AxiosError) => {
        setAddGroupRoleErrorMessage('Failed to perform sync.');
        err.message = 'RBACSyncDialog: ' + err.message;
        trackException(err);
      });
  };

  return (
    <Dialog
      isBlocking={false}
      hidden={!props.showRBACSyncDialog}
      dialogContentProps={{
        title: `RBAC Sync Info`,
        subText: subText
      }}
      modalProps={{
        overlay: {
          isDarkThemed: true
        }
      }}
    >
      <DialogFooter>
        <SalusPrimaryButton onClick={onRbacSyncClick} text="Perform Sync" disabled={!ableToSync() || syncComplete} />
        <DefaultButton
          onClick={(): void => props.setShowRBACSyncDialog(false)}
          text={syncComplete ? 'Done' : 'Cancel'}
        />
        {addGroupRoleErrorMessage && (
          <Stack>
            <Text style={{ textAlign: 'center', marginTop: 20, color: SharedColors.red20 }}>
              {addGroupRoleErrorMessage}
            </Text>
          </Stack>
        )}
      </DialogFooter>
    </Dialog>
  );
};
